Vue.component('exportFamily', {
    template: `
        <div id="exportFamily">

            <div class="content exportContent" id="documentContent">
                <memberInfo :fn="fn" :style="{marginBottom: '70px'}" v-for="member in membersData" v-if="membersData && membersData.length > 0" :exportData="member" :isExport="true" :exportMemberPn="member.c_publicationnumber" :exportMemberKd="member.c_kindcode"></memberInfo>
            </div>

        </div>
    `,
    data: function() {
        return {
            css: '',
            membersData: []
        };
    },

    props: ['members'],

    computed: {
        fn() {
            return this.$store.getters.fn;
        }
    },

    mounted() {

        EventBus.$on('EXPORT_FAMILY', () => {
            this.$store.commit('START_EXPORT');
            this.getMembersData();
        });

    },

    methods: {

        getMembersData() {

            let mapped = this.members.map(member => {
                return {
                    pn: member.c_publicationnumber,
                    kd: member.c_kindcode
                };
            })

            this.$store.dispatch('GET_EXPORT_DATA', {
                members: mapped,
                fn: this.fn
            })
                .then(res => {
                    this.membersData = res.data;
                    this.getCss();
                })
                .catch(err => {
                });

        },

        getCss() {
            axios.get('?page=getData&action=fetchCss')
                .then(res => {
                    this.css = res.data;
                    this.exportMember(res.data);
                })
                .catch(err => {
                    console.log(err);
                });
        },

        exportMember(css) {
            let elHtml = document.getElementById('exportFamily').innerHTML;

            let cssTag = '<style>' + css + '</style>';

            elHtml = cssTag + elHtml;
            var link = document.createElement('a');
            var mimeType = 'text/html';

            link.setAttribute('download', this.fn + '.html');
            link.setAttribute('href', 'data:' + mimeType + ';charset=utf-8,' + encodeURIComponent(elHtml));
            link.click();

            this.$store.commit('END_EXPORT');


        }

    }
});
